import theme from '@style';
import {BottomSheet} from '@rneui/themed';
import React, {useState, ReactNode, useCallback} from 'react';
import {Dimensions, DimensionValue, View} from 'react-native';
import styles from './index.module.scss';

export interface ButtomSheetOptions {
  /** 点击外围是否关闭 */
  backDropClose?: boolean;
  /** 从底下向上伸出的高度，如果没有则使用自动高度 */
  height?: DimensionValue;
  /** 最大宽度 */
  maxWidth?: number;
  /** 上圆角是多少 */
  topBorderRadius?: number;
  animationType?: 'fade' | 'none' | 'slide' | undefined;
  afterHidden?: () => void;
}

export function useBottomSheet(
  modalContent: ReactNode,
  options: ButtomSheetOptions = {},
) {
  const lastVisible = React.useRef(false);
  const [visible, setVisible] = useState<boolean>(false);
  const {
    backDropClose,
    height,
    maxWidth,
    topBorderRadius,
    animationType,
    afterHidden,
  } = options;
  const show = useCallback(() => {
    setVisible(true);
  }, []);
  const hide = useCallback(() => {
    setVisible(false);
  }, []);
  const handleBackDrop = () => {
    backDropClose && hide();
  };
  React.useEffect(() => {
    if (lastVisible.current && !visible) {
      afterHidden?.();
    }
    lastVisible.current = visible;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);
  const width =
    Dimensions.get('window').width > 500 ? 500 : Dimensions.get('window').width;
  return {
    renderModal: (
      <div className={styles.dialog}>
        <BottomSheet
          modalProps={{
            animationType: animationType || 'fade',
          }}
          isVisible={visible}
          onBackdropPress={handleBackDrop}
          // eslint-disable-next-line react-native/no-inline-styles
          containerStyle={{
            width: width,
            marginLeft: 'auto',
            marginRight: 'auto',
            left: 0,
            right: 0,
          }}>
          <View
            style={[
              theme.padding.l,
              theme.background.white,
              height ? {height: height} : {},
              maxWidth ? {maxWidth: maxWidth} : {},
              topBorderRadius
                ? {
                    borderTopLeftRadius: topBorderRadius,
                    borderTopRightRadius: topBorderRadius,
                  }
                : {},
            ]}>
            {modalContent}
          </View>
        </BottomSheet>
      </div>
    ),
    show,
    hide,
  };
}
